export default __webpack_public_path__ + "static/media/Belt of Bloodlust.72fc3e74.jpg";